module.exports = __webpack_public_path__ + "static/media/profile.fd39cffb.PNG";